import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import StyledAppbarPrimaryLoadingButton from 'common/theme/appbar/StyledAppbarPrimaryLoadingButton';

function AppBarPrimaryButton({ loading, onClick, label, ...rest }) {
  return (
    <StyledAppbarPrimaryLoadingButton
      {...rest}
      size="small"
      onClick={onClick}
      loading={loading}
      loadingIndicator={<CircularProgress color="inherit" size={16} />}
      variant="contained">
      <span>{label}</span>
    </StyledAppbarPrimaryLoadingButton>
  );
}

AppBarPrimaryButton.propTypes = {
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default AppBarPrimaryButton;
